;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import styles from "./styles.module.scss"
import { Typography } from "@mui/material"

function Header({ text }) {
  return (
    <div className={styles["header"]}>
      <Typography variant={"h1"}>{text}</Typography>
    </div>
  )
}

export default Header
